<template>
  <div class="work-tutor-review-component">
    <div class="header">
      <div>导师点评</div>
      <ym-button v-if="showReply"
                 class="reply-btn"
                 plain
                 type="primary"
                 size="extra-small"
                 round
                 @click="handleReplyBtn(tutorReview.tutor.id)"
      >回复
      </ym-button>
    </div>
    <div class="content">
      <div class="content-header">
        <div class="tutor-info-block">
          <ym-avatar class="user-avatar"
                     :avatar="tutorReview.tutor.avatar"
          />
          <div class="tutor-info">
            <div class="tutor-name">{{ tutorReview.tutor.name }}</div>
            <ym-score :score="tutorReview.score"></ym-score>
          </div>
        </div>
        <div class="date">{{ tutorReview.createdTime|formatTime('yyyy-MM-dd') }}</div>
      </div>
      <div class="review"
           :class="{ 'active': show }"
           v-html="tutorReview.content"
      >
      </div>
    </div>
    <div class="show-more-bar"
         v-if="show"
         @click="handleShowMoreContent"
    >
      全部点评内容
      <ym-icon class="ym-icon"
                name="down"
      />
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import YmScore from '@/components/YmScore';
  import Avatar from '@/components/Avatar';

  export default {
    name: 'WorkTutorReviewComponent',
    components: {
      YmScore,
      'ym-button': Button,
      'ym-avatar': Avatar,
    },
    props: {
      tutorReview: {
        type: Object,
        required: true,
      },
      showMore: {
        type: Boolean,
        required: true,
      },
      showReply: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        show: false,
      };
    },
    watch: {
      showMore: {
        deep: true,
        immediate: true,
        handler(val) {
          this.show = val;
        },
      },
    },
    methods: {
      handleReplyBtn(id) {
        const route = { name: 'MessageDetail', params: { id } };
        this.$router.push(route);
      },
      handleShowMoreContent() {
        this.show = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .work-tutor-review-component {
    margin-bottom: @size-small;
    background: @color-white;
  }

  .header {
    padding: @size-base;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    line-height: 1;
    border-bottom: @border-base;
  }

  .reply-btn {
    /deep/ .mint-button-text {
      font-weight: @font-weight-primary;
    }
  }

  .content {
    padding: 30px;
  }

  .content-header,
  .tutor-info-block {
    display: flex;
    justify-content: space-between;
    .user-avatar {
      margin-right: @size-small;
    }
  }

  .tutor-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .tutor-name {
    margin-top: @size-extra-small;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    line-height: 1;
  }

  .date {
    padding-top: @size-extra-small;
    font-size: @font-size-small;
    color: @color-text-lighter;
  }

  .review {
    margin-top: @size-base;
    font-size: @font-size-base;
    color: @color-text-light;
    line-height: 1.4;
    &.active {
      max-height: 414px;
      overflow: hidden;
    }
  }

  .show-more-bar {
    padding: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: @border-base;
    font-size: @font-size-base;
    line-height: 1;
    color: @color-text-lighter;
    .ym-icon {
      margin-left: @size-base;
      font-size: @font-size-extra-small;
    }
  }

</style>
